<template>
    <CreateDept></CreateDept>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CreateDept = defineAsyncComponent(() =>
    import("../../components/Hr/CreateDepartment/Table.vue")
);

export default {
    name: "HR_CreateDept", //The name you are in should not equal the name of the component you are importing.
    components: { CreateDept, AuthLayout },
};
</script>

<style scoped></style>
